import { createFileRoute } from '@tanstack/react-router';
import { CompletionPage } from '../../features/start/completion-page.tsx';
import { guardPermission } from '../../shell/guard.ts';

// The owner's induction completion table and Delegate Training Log export (T33b, spec J6.5).
export const Route = createFileRoute('/_authed/start/completion')({
  beforeLoad: guardPermission('induction.manage'),
  component: CompletionPage,
});
